export function hexToRgba(hex, opacity = 1) {
  hex = hex.replace('#', '')
  hex = hex.length === 3 ? `${hex}${hex}` : hex
  let red = parseInt(hex.substring(0, 2), 16)
  let green = parseInt(hex.substring(2, 4), 16)
  let blue = parseInt(hex.substring(4, 6), 16)
  return `rgba(${red}, ${green}, ${blue}, ${opacity})`
}



// WEBPACK FOOTER //
// ./src/utils/hexToRgba.js